import React, { useState, useContext, useEffect } from "react";
import Avatar from "@material-ui/core/Avatar";
import Checkbox from "@material-ui/core/Checkbox";
import Link from "@material-ui/core/Link";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import { AppContext, DispatchContext } from "../AppContext";
import * as actions from "../actions/actions";
import Service from "../services/service";
import Divider from '@material-ui/core/Divider';
import { config, prices, resolveNotificationMessage } from '../helpers/constants';
import { Tooltip, Switch, FormGroup, Select, FormControlLabel, FormHelperText, Paper, Grid, Box, Typography, InputLabel, FormControl, Button, Tab, Tabs, AppBar, Dialog, List, DialogActions, DialogContent, DialogTitle, ListItem, TextField, MenuItem } from "@material-ui/core";
import LanguageMenu from "./LanguageMenu";
import PlagAwareLogo from "./PlagAwareLogo";
import Copyright from "./Copyright";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    height: "100vh",
    background: theme.palette.background.image,
    backgroundSize: "cover",
    padding: theme.spacing(2),
    justifyContent: "center",
    alignItems: "center"
  },
  langSelect: {
    position: "absolute",
    top: "20px",
    right: "20px"
  },
}));

export default function FullScreenPage(props) {
  const {children, logoClickUrl} = props;
  const classes = useStyles();
  const state = useContext(AppContext);
  const s = state.strings;


  return (
      <div className={classes.root}>
        <div className={classes.langSelect}>
          <LanguageMenu />
        </div>
        <PlagAwareLogo logoClickUrl={ logoClickUrl || config.backendUrl + s.links.home}/>
        <Copyright /> 
        {children}
      </div>
  );
}
